import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const TitleIcon = styled(Icon)`
  font-size: 3rem;
  margin: 0 0.75rem 1rem;
`;

const Container = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

export default ({ name }) => (
  <Container>
    <TitleIcon name={name} />
  </Container>
);
